import React from 'react';
import { useUsers } from '../context/UsersContext';
import { HiUsers } from 'react-icons/hi2';
import { MdShield, MdWork, MdPerson, MdPersonOff } from 'react-icons/md';

export default function UserStatsGrid() {
  const { stats: counts, loading, error } = useUsers();
  const stats = [
    {
      id: 1,
      title: 'Total Users',
      value: counts.total,
      subtitle: 'All users in system',
      icon: HiUsers,
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
    },
    {
      id: 2,
      title: 'Admins',
      value: counts.admins,
      subtitle: 'Full access',
      icon: MdShield,
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600',
    },
    {
      id: 3,
      title: 'Branch Managers',
      value: counts.managers,
      subtitle: 'Operation access',
      icon: MdWork,
      bgColor: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
    },
    {
      id: 4,
      title: 'Staff',
      value: counts.staff,
      subtitle: 'Task access',
      icon: MdPerson,
      bgColor: 'bg-amber-50',
      iconColor: 'text-amber-500',
    },
    {
      id: 5,
      title: 'Inactive Users',
      value: counts.inactive,
      subtitle: 'Not active',
      icon: MdPersonOff,
      bgColor: 'bg-slate-50',
      iconColor: 'text-slate-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 p-6 bg-slate-50/50">
      {stats.map((item) => {
        const IconComponent = item.icon;
        return (
          <div
            key={item.id}
            className="flex items-center gap-4 rounded-xl border border-slate-100 bg-white p-4 shadow-sm transition hover:shadow-md"
          >
            {/* Circular Icon Wrapper */}
            <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${item.bgColor}`}>
              <IconComponent className={`h-6 w-6 ${item.iconColor}`} />
            </div>

            {/* Labels and Metrics */}
            <div className="flex flex-col min-w-0">
              <span className="text-xs font-semibold text-slate-500 truncate">
                {item.title}
              </span>
              <span className="text-2xl font-bold text-slate-900 leading-tight my-0.5">
                {loading || error ? '—' : item.value}
              </span>
              <span className="text-[11px] font-medium text-slate-400 truncate">
                {item.subtitle}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
